import React, { CSSProperties } from 'react';
import { ImageSvg } from '../utils/customIcon';

interface Props {
	containerClass?: String;
	imgClass?: String;
	containerCss?: CSSProperties;
	imgCss?: CSSProperties;
}

export const DairyCow = (props: Props) => {
	const svg = require('./dairy-cow.svg');
	return <ImageSvg {...props} svg={svg} />;
};
